module.exports = __webpack_public_path__ + "img/msg-laba.09855546.png";